import { useSelector } from "react-redux";
import { selectGlobalState } from "../state-management/selectors";

export default function activeitesQuantity() {
  const { newsData, articlesData, departmentsData, projectsData, usersData } =
    useSelector(selectGlobalState);

  const totalActivities =
    newsData?.length + articlesData?.length + projectsData?.length;

  const articleCounts = articlesData.reduce(
    (acc: Record<string, number>, art: any) => {
      acc[art.department_id] = (acc[art.department_id] || 0) + 1;
      return acc;
    },
    {}
  );

  const newsCounts = newsData.reduce(
    (acc: Record<string, number>, news: any) => {
      acc[news.department_id] = (acc[news.department_id] || 0) + 1;
      return acc;
    },
    {}
  );

  const projectCounts = projectsData.reduce(
    (acc: Record<string, number>, pro: any) => {
      acc[pro.department_id] = (acc[pro.department_id] || 0) + 1;
      return acc;
    },
    {}
  );

  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

  const data = departmentsData.map((item: any) => {
    const ar = articleCounts[item._id] || 0;
    const ne = newsCounts[item._id] || 0;
    const pr = projectCounts[item._id] || 0;
    const ma =
      usersData.find((user: any) => user._id === item?.manager_id) || "";
  
    const departmentDetailes = {
      name: item.name,
      icon: item.icon,
      manager: `${ma.firstname} ${ma.lastname}`,
      primaryColor: item.color_primary,
      secondaryColor: item.color_secondary,
      isActive: item.is_active,
      recentActivity: 0,
    };
    const userDetailes = usersData
      .filter(
        (user: any) => user.main_department === item._id && user.is_active
      )
      .map((user: any) => ({
        userId: user._id,
        userPicture: user.picture,
        fullName: `${user.firstname} ${user.lastname}`,
        recentActivity:
          articlesData.filter(
            (it: any) =>
              it.created_by === user._id &&
              new Date(it.created_at) >= oneMonthAgo
          ).length +
          newsData.filter(
            (it: any) =>
              it.created_by === user._id &&
              new Date(it.created_at) >= oneMonthAgo
          ).length +
          projectsData.filter(
            (it: any) =>
              it.created_by === user._id &&
              new Date(it.created_at) >= oneMonthAgo
          ).length,
      }));

    return {
      departmentName: item.name,
      departmentDetailes,
      departmentUsers: userDetailes,
      activityPercentage: Math.round(((ar + ne + pr) * 100) / totalActivities),
      articleQuantity: ar,
      newsQuantity: ne,
      projectQuantity: pr,
    };
  });
  return data;
}
